import { render, staticRenderFns } from "./ProfileUsers.vue?vue&type=template&id=4a2ff380&scoped=true"
import script from "./ProfileUsers.vue?vue&type=script&lang=js"
export * from "./ProfileUsers.vue?vue&type=script&lang=js"
import style0 from "./ProfileUsers.vue?vue&type=style&index=0&id=4a2ff380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ff380",
  null
  
)

export default component.exports